import L from "leaflet";
import caricon from "../../images/caricon.png";
import { ImLocation2 } from "react-icons/im";

export const carIcon = new L.Icon({
    iconUrl: caricon,
    iconSize: [55, 75],
    iconAnchor: [17, 46], //leaflet top, bottom
    popupAnchor: [0, -46],
});
export const userIcon = new L.Icon({
    iconUrl: ImLocation2,
    iconSize: [90, 70],
    iconAnchor: [17, 46], //leaflet top, bottom
    popupAnchor: [0, -46],
});
export const locationIcon = new L.Icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png"
});